import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  profileIcon: {
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    boxShadow: "4.5px 4.5px 4.5px 0px #0C38911A",
  },
}));
